module.exports = __webpack_public_path__ + "img/Group 4646.3c5f3a0a.png";